import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const BDInsights = () => {
  const { t } = useI18n();
  return (
    <div>
      <section className="py-28 lg:py-36 bg-[#0A192F] text-white grain">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="overline text-[#D4AF37] mb-6">{t("ins.hero.eyebrow")}</div>
          <h1 className="font-bd text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.02] max-w-4xl">
            {t("ins.hero.title.a")} <span className="text-[#D4AF37]">{t("ins.hero.title.b")}</span> {t("ins.hero.title.c")}
          </h1>
          <p className="mt-8 text-lg sm:text-xl text-white/75 max-w-3xl leading-relaxed">
            {t("ins.hero.body")}
          </p>
        </div>
      </section>

      <section className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[0, 1, 2].map((idx) => (
              <article key={idx} className="bg-white border border-[#0A192F]/10 lift-card p-8 flex flex-col group cursor-pointer">
                <div className="overline text-[#F58220]">{t(`ins.items.${idx}.tag`)}</div>
                <div className="text-xs text-[#0A192F]/50 mt-2">{t(`ins.items.${idx}.date`)}</div>
                <h3 className="font-bd text-xl text-[#0A192F] mt-5 tracking-tight leading-snug flex-1">{t(`ins.items.${idx}.title`)}</h3>
                <p className="mt-4 text-sm text-[#0A192F]/70 leading-relaxed">{t(`ins.items.${idx}.excerpt`)}</p>
                <div className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0A192F] group-hover:text-[#F58220] transition-colors">
                  {t("ins.items.cta")} <ArrowUpRight size={14} />
                </div>
                <div className="mt-6 section-num">— {String(idx + 1).padStart(2, "0")}</div>
              </article>
            ))}
          </div>
          <div className="mt-16 text-center text-[#0A192F]/60 text-sm">
            {t("ins.footer")}
          </div>
        </div>
      </section>
    </div>
  );
};

export default BDInsights;
